import './global.css';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { app } from 'cbmms-js/web';
import initApp from 'utils/initApp';
import Loading from 'ui/base/Loading';
import Empty from 'ui/Empty';
import Tips from './alert/Tips';
import Confirm from './alert/Confirm';
import ShareBrowserAlert from './alert/ShareBrowserAlert';
import ShareWechatAlert from './alert/ShareWechatAlert';
import Toast from './alert/Toast'
const App = loadable(() => import('./App'));

export default function Root() {
  const [ready, setReady] = useState(false);
  const [errMsg, setErrMsg] = useState(null);
  const shareRef = useRef();
  const confirmRef = useRef();
  const tipsRef = useRef();
  const toastRef = useRef()
  useEffect(() => {
    function showTips(tipsType, message) {
      return tipsRef.current.show(tipsType, message);
    }
    function showToast(tipsType, message,awaiting) {
      return toastRef.current.show(tipsType, message,awaiting);
    }
    function showToastHide() {
      return toastRef.current.hide();
    }
    function showConfirm(options) {
      return confirmRef.current.show(options);
    }

    function showShareAlert() {
      return shareRef.current.show(app.platformAttrs.shareDict);
    }

    function setPlatformAttrs(attrs) {
      app.platformAttrs = attrs;

      console.log('setPlatformAttrs:', attrs);
      const { title, backgroundColor, shareDict } = attrs;

      document.title = title || '';
      document.documentElement.style.backgroundColor =
        backgroundColor || '#F7F8F8';

      if (app.weapp) {
        app.weapp.onShare(shareDict);
      } else if (app.wechat) {
        app.wechat.onShare(shareDict);
      }
    }

    initApp({ showTips, showConfirm, showShareAlert, setPlatformAttrs,showToast,showToastHide })
      .then(() => {
        setReady(true);
      })
      .catch(error => {
        setErrMsg(error.message || '未知错误');
      });
  }, []);

  if (errMsg) {
    return <Empty>{errMsg}</Empty>;
  }
  if (!ready) {
    return <Loading />;
  }

  let ShareAlert;

  if (app.wechat || app.weapp) {
    ShareAlert = ShareWechatAlert;
  } else {
    ShareAlert = ShareBrowserAlert;
  }

  return (
    <Provider store={app.store}>
      <Router history={app.history}>
        <Route>
          {({ location }) => (
            <Fragment>
              <ShareAlert ref={shareRef} location={location} />
              <Confirm ref={confirmRef} location={location} />
              <Tips ref={tipsRef} location={location} />
              <Toast ref={toastRef}></Toast>
            </Fragment>
          )}
        </Route>
        <Route component={App} />
      </Router>
    </Provider>
  );
}
